
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scopri-bs",
      function () {
        return require("private-next-pages/scopri-bs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scopri-bs"])
      });
    }
  